import { render, staticRenderFns } from "./DeleteCouponRuleFee.vue?vue&type=template&id=08ca3522&scoped=true"
import script from "./DeleteCouponRuleFee.vue?vue&type=script&lang=js"
export * from "./DeleteCouponRuleFee.vue?vue&type=script&lang=js"
import style0 from "./DeleteCouponRuleFee.vue?vue&type=style&index=0&id=08ca3522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ca3522",
  null
  
)

export default component.exports